onReady(() => {
    const cardModules = document.querySelectorAll('.cards.module')

    const flipCardHandler = (card) => (event) => {
        event.preventDefault()
        card.classList.add('flipped')
    }

    for (const module of cardModules) {
        const cards = module.querySelectorAll('.card')
        for (const card of cards) {
            card.querySelector('.flip-button.cta-link')
                .addEventListener('click', flipCardHandler(card))
            card.querySelector('.flip-button.cta-button')
                .addEventListener('click', flipCardHandler(card))
            card.querySelector('.close-button')
                .addEventListener('click', () => card.classList.remove('flipped'))
        }
    }
});
